import React from 'react'
import { Switch } from 'react-router-dom'
import LoadableRoute from '../components/features/share/loadable/loadableRoute'
import { PrivateRoute, PublicRoute } from './routePermission'

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster'),
})
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank'),
})

const LayoutBlack = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlack'),
})

const LayoutDisplay = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutDisplay'),
})



//Features
//Auth
const Login = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController'),
})
const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController'),
})
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController'),
})

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeController'),
})

//Display Table Task
//TableTaskController
const TableTaskController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/listTable/controllers/tableTaskController')
})

const SetupTableController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/setupTable/controllers/setupTableController')
})

const TableTaskOnJobController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/tableTaskOnJob/controllers/tableTaskOnJobController')
})

const TableTaskOnStartController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/tableTaskOnStart/controllers/tableTaskOnStartController')
})

const ReportAsFinishedController = LoadableRoute({
    loader: () => import('../components/features/reportAsFinish/controller/reportAsFinishController')
    // loader: () => import('../components/features/displayTableTask/reportAsFinish/controllers/reportAsFinishedController')
})

const SetupDisplayNameController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/displayNameSetup/controllers/setupDisplayName')
})

export default () => (
    <Switch>

        {/* <PrivateRoute exact path='/masterData/settings' component={HomeController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterData' component={HomeController} layout={LayoutMaster} />*/}

        <PublicRoute path='/reportAsFinished/:id' component={ReportAsFinishedController} layout={LayoutDisplay} />
        <PublicRoute path='/taskOnStart/:id' component={TableTaskOnStartController} layout={LayoutDisplay} />
        <PublicRoute path='/taskOnJob/:id' component={TableTaskOnJobController} layout={LayoutDisplay} />
        <PublicRoute path='/taskOnJob' component={TableTaskOnJobController} layout={LayoutDisplay} />
        <PublicRoute path='/setup' component={SetupTableController} layout={LayoutDisplay} />
        <PublicRoute path='/table' component={TableTaskController} layout={LayoutDisplay} />

        <PrivateRoute exact path='/admin' component={HomeController} layout={LayoutMaster} />
        <PublicRoute path='/' component={SetupDisplayNameController} layout={LayoutBlack} />


        <PublicRoute path='/login' component={Login} layout={LayoutBlank} />
        <PublicRoute path='/unauthen' component={UnAuthenController} layout={LayoutMaster} />
        <PublicRoute component={NotFoundController} layout={LayoutMaster} />

    </Switch>
)


// WEBPACK FOOTER //
// ./src/app/routes/Routes.js